// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"iymZe","breadcrumbs__item":"rXtVE","focus-visible":"VAs71","js-focus-visible":"eW40m","breadcrumbs__item-wrapper":"yQ3AS"};